import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { RequestBlocksFn } from './types';

interface Props {
    requestBlocks: RequestBlocksFn;
    setUpdate: (fn: () => void) => void;
}

interface State {
    blocks: any;
}

export default class App extends Component<Props, State> {
    public state = { blocks: [] };

    constructor(props: Props) {
        super(props);
        this.props.setUpdate(this.forceUpdate.bind(this));
    }

    public componentDidMount() {
        this.props.setUpdate(this.forceUpdate.bind(this));
    }

    public componentDidUpdate() {
        this.props.setUpdate(this.forceUpdate.bind(this));
    }

    public render() {
        const blocks = this.props.requestBlocks();
        return <>
            {Object.entries(blocks).map(([id, {Block, props}]) =>
                ReactDOM.createPortal(
                    <Block {...props} />,
                    document.getElementById(id),
                    id
                )
            )}
        </>;
    }
}
